import { BadgeCheck, CarFront, FileCheck2, ShieldCheck, WalletCards } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Checklist, CTASection, PageHero, PrototypeNotice, SectionIntro } from '../components/Sections';
import { captainSteps } from '../data';

export function Captains() {
  return (
    <>
      <PageHero
        eyebrow="Drive with Sawwari"
        title="Build your Captain profile with confidence."
        text="A guided registration journey for eligible drivers and vehicles, designed to keep document status and next actions easy to understand."
        tone="mint"
      >
        <div className="button-row">
          <Link className="button button--primary" to="#captain-path">Preview registration</Link>
          <Link className="button button--secondary" to="/captain-terms">Captain terms</Link>
        </div>
      </PageHero>

      <section className="section" id="captain-path">
        <div className="container">
          <SectionIntro
            eyebrow="Captain path"
            title="From secure account to Departure Lounge."
            text="Each step is reusable as a website explanation, app onboarding guide or support reference."
          />
          <div className="captain-steps">
            {captainSteps.map((step) => (
              <article key={step.number}>
                <span>{step.number}</span>
                <div><h3>{step.title}</h3><p>{step.text}</p></div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--ink captain-requirements">
        <div className="container captain-requirements__grid">
          <div>
            <span className="eyebrow">Prepare before you begin</span>
            <h2>A clearer application starts with clear documents.</h2>
            <p>Final requirements can be managed through the administrative configuration and registration experience.</p>
            <Checklist items={[
              'CNIC details with clear front and back images',
              'Current address and required identity information',
              'Driving licence and category-appropriate eligibility',
              'Vehicle registration and ownership documents',
              'Any additional document requested during review',
            ]} />
          </div>
          <div className="captain-status-card">
            <div className="captain-status-card__head">
              <span className="captain-avatar">ZA</span>
              <div><small>Captain Centre</small><strong>Application overview</strong></div>
              <span className="status-pill status-pill--amber"><i /> In review</span>
            </div>
            <div className="status-progress"><i /><i /><i /><i /></div>
            <div className="status-list">
              <span><ShieldCheck /> Identity profile <b>Submitted</b></span>
              <span><FileCheck2 /> Documents <b>In review</b></span>
              <span><CarFront /> Vehicle <b>Submitted</b></span>
              <span><BadgeCheck /> Final decision <b>Pending</b></span>
            </div>
            <button type="button" className="button button--primary button--full">View application</button>
            <small className="prototype-label">Illustrative prototype state</small>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container captain-principles">
          <SectionIntro
            eyebrow="Captain experience"
            title="Status that tells you what to do next."
            align="center"
          />
          <div className="principle-grid">
            <article><FileCheck2 /><h3>Versioned documents</h3><p>Re-uploads create a clear new record without hiding the review history.</p></article>
            <article><BadgeCheck /><h3>Actionable reasons</h3><p>Rejected items can show a specific reason and the next required action.</p></article>
            <article><WalletCards /><h3>Connected account</h3><p>Captain profile, rides, documents and wallet experience share one account foundation.</p></article>
          </div>
          <PrototypeNotice>Eligibility, fees, commission, incentives and vehicle-category rules remain subject to final launch configuration and Captain terms.</PrototypeNotice>
        </div>
      </section>

      <CTASection
        title="Build a Captain experience that earns trust."
        text="Use the prototype as a public explanation today and connect it to registration when the launch workflow is ready."
        primary={{ label: 'Read Captain terms', to: '/captain-terms' }}
        secondary={{ label: 'Explore safety', to: '/safety' }}
      />
    </>
  );
}
